import { useTranslation } from "react-i18next"
import { AreProAccountWrapper } from "./styles"
import { IoClose } from "react-icons/io5"
import CustomButton from "@Common/CustomButton"
import WheelHouseLarge from "@assets/svg/wheelHouse_large.svg?react"
import { Dispatch, SetStateAction } from "react"
interface IProps {
	closePopUp: Dispatch<SetStateAction<boolean>>
}
export default function AreProAccount({ closePopUp }: IProps) {
	const { t } = useTranslation()
	return (
		<AreProAccountWrapper>
			<div>
				<div onClick={() => closePopUp(false)}>
					<IoClose />
				</div>
				<div>
					<WheelHouseLarge />
				</div>
				<div>
					{t("CALENDAR.To automate Wellhouse, please upgrade your account")}
				</div>
				<div>
					<CustomButton
						label={t("CALENDAR.Account Upgrade")}
						customPadding='16px 24px'
						customBG='#5B3FFF'
						customColor='#fff'
						type='button'
						onClick={() =>
							(window.location.href = "https://www.usewheelhouse.com/pricing")
						}
					/>
				</div>
			</div>
		</AreProAccountWrapper>
	)
}
